/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RequiredConstraint } from "./RequiredConstraint";
import { UniqueConstraint } from "./UniqueConstraint";
import { ExternalConstraint } from "./ExternalConstraint";
import { StoredConstraint } from "./StoredConstraint";
export const Constraint = core.serialization
    .union("type", {
    required: RequiredConstraint,
    unique: UniqueConstraint,
    computed: core.serialization.object({}),
    external: ExternalConstraint,
    stored: StoredConstraint,
})
    .transform({
    transform: (value) => value,
    untransform: (value) => value,
});
